module.exports = __webpack_public_path__ + "static/media/18.5400d3c3.mp3";